import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import PartnerSessionMaxWatcher from '../admin-shared/PartnerSessionMaxWatcher';
import PartnerSessionTimeoutModal from '../admin-shared/PartnerSessionTimeoutModal';
import TrialPopup from './components/TrialPopup';
import ModernAlertHost from './components/ModernAlertHost';
import AppModal from './components/AppModal';
import { TrialProvider } from './context/TrialContext';
import { UserProvider } from './context/UserContext';
import { API_BASE, PORTAL_ID, clearPortalStorage } from './utils/api';
import { applyThemeToDocument, getStoredTheme } from './utils/theme';

import './assets/fonts/local-fonts.css';
import './index.css';

export default function SalonAdminFlowLayout() {
  useEffect(() => {
    applyThemeToDocument(getStoredTheme());
  }, []);

  useEffect(() => {
    const orig = window.fetch.bind(window);
    window.fetch = (input, init = {}) => {
      const url = typeof input === "string" ? input : input?.url || "";
      if (API_BASE && typeof url === "string" && url.startsWith(API_BASE)) {
        const headers = new Headers(init.headers || {});
        headers.set("X-Naturals-Portal", PORTAL_ID);
        return orig(input, { ...init, headers, credentials: init.credentials || "include" });
      }
      return orig(input, init);
    };
    return () => {
      window.fetch = orig;
    };
  }, []);

  return (
    <UserProvider>
      <TrialProvider>
        <PartnerSessionMaxWatcher portalId={PORTAL_ID} loginPathPrefix="/nyafaz-ep/login" />
        <PartnerSessionTimeoutModal
          AppModal={AppModal}
          clearPortalStorage={clearPortalStorage}
          loginPath="/nyafaz-ep/login"
          portalId={PORTAL_ID}
        />
        <TrialPopup />
        <ModernAlertHost />
        <Outlet />
      </TrialProvider>
    </UserProvider>
  );
}
